import { icons } from 'feather-icons';
import { convertToTitleCase } from '../collectionForm/utils';

export default (editor, opts = {}) => {
  const cmd = editor.Commands;
  const {
    modalTitle,
    codeViewOptions,
    commandDrapcodeIconsCode,
    refs,
    commands,
    labels,
    placeholderContent,
    selectArrow,
    titles,
    tags,
  } = opts;
  const { keyDrapCodeIconsCustomCode, drapcodeIconsRef } = refs;

  const appendToContent = (target, content) => {
    if (content instanceof HTMLElement) {
      target.appendChild(content);
    } else if (content) {
      target.insertAdjacentHTML('beforeend', content);
    }
  };

  let drapcodeIconsSelectList = [];
  const feather = require('feather-icons');

  cmd.add(commands.drapcode_icons_custom_code, {
    keyDrapCodeIconsCustomCode,

    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const target = this.target;

      if (target && target.get('editable')) {
        this.showDrapcodeIconsCode(target);
      }
    },

    stop(editor) {
      editor.Modal.close();
    },

    async showDrapcodeIconsCode(target) {
      const { editor, options } = this;
      const title = options.title || modalTitle;

      drapcodeIconsSelectList = [];
      const content = this.getContent();
      const code = target.get(keyDrapCodeIconsCustomCode) || '';
      editor.Modal.open({ title, content })
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));
      this.getCodeViewer().setContent(code);
    },
    getPreContent() {},
    getPostContent() {},
    getBreakPoint() {
      const contentBreak = document.createElement('br');
      return contentBreak;
    },

    getContent() {
      const { editor } = this;
      const content = document.createElement('div');
      const galleryDiv = document.createElement('div');
      const categoryLabel = document.createElement('label');

      const selectCategoryOptionDiv = document.createElement('div');
      const selectCategoryOptionArrow = document.createElement('div');
      const selectCategoryOption = document.createElement('select');

      const codeViewer = this.getCodeViewer();
      const pfx = editor.getConfig('stylePrefix');

      content.className = `${pfx}drapcode-icons`;
      categoryLabel.className = `${pfx}drapcode-icons-category-label col-5 no-break`;
      galleryDiv.className = `${pfx}drapcode-icons-gallery-div row`;

      selectCategoryOption.className = `${pfx}drapcode-icons-category`;
      selectCategoryOptionDiv.className = `${pfx}drapcode-icons-category ${pfx}field ${pfx}select col-4 two-break`;
      selectCategoryOptionArrow.className = `${pfx}drapcode-icons-category ${pfx}sel-arrow`;

      selectCategoryOption.id = `${pfx}drapcode-icons-category-select`;
      selectCategoryOptionDiv.id = `${pfx}drapcode-icons-category-select-div`;
      categoryLabel.id = `${pfx}drapcode-icons-category-label`;
      galleryDiv.id = `${pfx}drapcode-icons-gallery-div`;

      appendToContent(content, this.getPreContent());
      appendToContent(categoryLabel, this.getPreContent());
      appendToContent(selectCategoryOptionDiv, this.getPreContent());
      appendToContent(selectCategoryOption, this.getPreContent());
      appendToContent(galleryDiv, this.getPreContent());

      //Create and append the category options
      let optionCategory = document.createElement('option');
      optionCategory.value = 'ALL';
      optionCategory.text = '-- Select One --';
      selectCategoryOption.appendChild(optionCategory);

      //Create and append the section category options
      tags.forEach(elementCategory => {
        let optionCategory = document.createElement('option');
        optionCategory.value = elementCategory.value;
        optionCategory.text = elementCategory.label;

        let attrTitle = document.createAttribute('title');
        attrTitle.value = elementCategory.label;
        optionCategory.setAttributeNode(attrTitle);

        selectCategoryOption.appendChild(optionCategory);
      });

      categoryLabel.innerHTML = `Select Category`;
      categoryLabel.style = `text-align: right;`;

      this.loadIconList(drapcodeIconsSelectList, galleryDiv);

      selectCategoryOption.onchange = () => this.loadIconList(drapcodeIconsSelectList, galleryDiv);

      let childComponents = [
        categoryLabel,
        selectCategoryOptionDiv,
        galleryDiv,
        codeViewer.getElement(),
      ];
      this.appendChildComponentsToContent(content, childComponents);

      selectCategoryOptionDiv.appendChild(selectCategoryOption);
      selectCategoryOptionDiv.style = `display:inline-block;float-right;`;
      selectCategoryOptionArrow.innerHTML = selectArrow;
      selectCategoryOptionDiv.appendChild(selectCategoryOptionArrow);

      appendToContent(selectCategoryOption, this.getPostContent());
      appendToContent(selectCategoryOptionDiv, this.getPostContent());
      appendToContent(categoryLabel, this.getPostContent());
      appendToContent(galleryDiv, this.getPostContent());
      appendToContent(content, this.getPostContent());
      codeViewer.refresh();
      setTimeout(() => codeViewer.focus(), 0);
      return content;
    },

    appendChildComponentsToContent(content, childrens) {
      childrens.forEach(child => {
        if (child.id === '' || child.id === undefined) {
          child.style = `display: none; visibility: hidden; height: 0vh;`;
          content.appendChild(child);
        } else {
          content.appendChild(child);

          if (!child.className.includes('no-break')) {
            content.appendChild(this.getBreakPoint());
          }
          if (child.className.includes('two-break')) {
            content.appendChild(this.getBreakPoint());
          }
        }
      });
    },

    handleSave() {
      const { editor, target } = this;
      if (this.getCodeViewer().getContent() === '') {
        //Set Default Icon When No Icon is Selected.
        this.getCodeViewer().setContent(placeholderContent);
      }
      const code = this.getCodeViewer().getContent();
      target.set(keyDrapCodeIconsCustomCode, code);
      editor.Modal.close();
      //Open Icon Component Settings
      editor.select(target);
      editor.Commands.run('tlb-trait-setting', { event });
    },

    async loadIconList(drapcodeIconsSelectList, galleryDiv) {
      const { editor, options } = this;
      const pfx = editor.getConfig('stylePrefix');
      const categorySelect = document.querySelector(
        `select[id=${pfx}drapcode-icons-category-select]`,
      );
      const categoryValue = categorySelect ? categorySelect.value : 'ALL';
      if (categoryValue) {
        drapcodeIconsSelectList = [];

        let filterIcons = Object.entries(icons).filter(
          ([key, icon]) => icon.tags.includes(categoryValue) || icon.name.includes(categoryValue),
        );

        if (categoryValue === 'ALL') {
          filterIcons = Object.entries(icons).filter(([key, icon]) => icon.name);
        }

        if (filterIcons) {
          filterIcons.map(drapcodeIconsBlock => {
            if (drapcodeIconsBlock[1].name) {
              let drapcodeIconsSelectObj = {};
              drapcodeIconsSelectObj['id'] = drapcodeIconsBlock[1].name;
              drapcodeIconsSelectObj['icon'] = drapcodeIconsBlock[1];
              drapcodeIconsSelectList.push(drapcodeIconsSelectObj);
            }
          });
        }

        galleryDiv.innerHTML = '';
        drapcodeIconsSelectList.forEach(element => {
          let attrTitle = document.createAttribute('title');
          attrTitle.value = `Click to add ${convertToTitleCase(element.icon.name)} icon to Canvas`;

          let componentImage = document.createElement('div');
          componentImage.id = `${pfx}drapcode-icons-${element.id}`;
          componentImage.className = `${pfx}drapcode-icons`;
          componentImage.setAttributeNode(attrTitle);
          componentImage.innerHTML = `

        <div class="preview-drapcode-icons">
          <span class="inner-html">
            <div class="mkp-components">
            ${feather.icons[element.id].toSvg({ stroke: '#262a42' })}
            </div>
          </span>
          <!-- <span class="label text-center">${element.icon.name}</span> -->
        </div>

        `;
          //Add Selected Icon on Canvas in Single Click
          componentImage.onclick = () => {
            this.handleClick(element, drapcodeIconsSelectList, galleryDiv);
            this.handleSave();
          };

          //Add Selected Icon on Canvas in Double Click
          // componentImage.ondblclick = () => {
          //   this.handleClick(element, drapcodeIconsSelectList, galleryDiv);
          //   this.handleSave();
          // };

          galleryDiv.appendChild(componentImage);
          galleryDiv.style = `display: flex; visibility:visible;`;
        });
      } else {
        galleryDiv.innerHTML = '';
        galleryDiv.style = `display:flex; visibility:hidden;`;
      }
    },

    async handleClick(selectedIconSection, drapcodeIconsSelectList, galleryDiv) {
      const { editor, options } = this;
      const pfx = editor.getConfig('stylePrefix');
      const iconComponents = document.querySelectorAll(`div.${pfx}drapcode-icons`);
      const selectedIconComponent = document.querySelector(
        `div[id=${pfx}drapcode-icons-${selectedIconSection.id}]`,
      );
      const selectCompContainer = selectedIconComponent.querySelector(`.inner-html`);

      iconComponents.forEach(iconComp => {
        let iconCompLabelBtn = iconComp.querySelector(`.inner-html`);
        iconCompLabelBtn.classList.remove('selected-drapcode-icon-comp');
      });
      selectCompContainer.classList.add('selected-drapcode-icon-comp');

      if (selectedIconComponent) {
        let mixedContent = feather.icons[selectedIconSection.id].toSvg({
          'data-gjs': drapcodeIconsRef + '-svg',
          'data-gjs-custom-name': 'Svg',
          'data-gjs-copyable': 'false',
          'data-gjs-removable': 'false',
          'data-gjs-selectable': 'false',
          'data-gjs-draggable': 'false',
          draggable: 'false',
        });
        this.getCodeViewer().setContent(mixedContent);
      } else {
        this.getCodeViewer().setContent(placeholderContent);
      }
    },

    getCodeViewer() {
      const { editor } = this;

      if (!this.codeViewer) {
        this.codeViewer = editor.CodeManager.createViewer({
          codeName: 'htmlmixed',
          theme: 'hopscotch',
          readOnly: 0,
          ...codeViewOptions,
        });
      }

      return this.codeViewer;
    },

    ...commandDrapcodeIconsCode,
  });
};
